var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',_vm._g(_vm._b({class:this.iconOnly !== true && this.icon.length > 0
      ? 'icon-button icon'
      : this.icon.length > 0
      ? 'icon-button'
      : '',attrs:{"tile":"","icon":_vm.iconOnly,"active-class":this.enabled && this.enabled === true ? 'disabled-bg' : ''}},'v-btn',_vm.$attrs,false),_vm.$listeners),[(this.icon && this.icon.length > 0)?_c('v-icon',[_vm._v(_vm._s(this.icon))]):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }